export default "__VITE_ASSET__BADNj_8i__"